export default "__VITE_PUBLIC_ASSET__0dfe51f1__"